import { directSupabase } from '../lib/supabaseClient';

type FavoriteRow = {
  style_id: number;
};

export const windowStyleFavoritesService = {
  async listFavoriteStyleIds(): Promise<number[]> {
    const { data: auth } = await directSupabase.auth.getUser();
    const userId = auth.user?.id;
    if (!userId) return [];

    const { data, error } = await directSupabase
      .from('window_style_favorites')
      .select('style_id')
      .eq('user_id', userId);

    if (error) throw new Error(error.message);
    return (data || []).map((r: FavoriteRow) => Number(r.style_id)).filter((n) => Number.isFinite(n));
  },

  async setFavorite(styleId: number, isFavorite: boolean): Promise<void> {
    const { data: auth } = await directSupabase.auth.getUser();
    const userId = auth.user?.id;
    if (!userId) throw new Error('Not authenticated');

    if (isFavorite) {
      const { error } = await directSupabase
        .from('window_style_favorites')
        .upsert({ user_id: userId, style_id: styleId }, { onConflict: 'user_id,style_id' });
      if (error) throw new Error(error.message);
      return;
    }

    const { error } = await directSupabase
      .from('window_style_favorites')
      .delete()
      .eq('user_id', userId)
      .eq('style_id', styleId);
    if (error) throw new Error(error.message);
  },
};

